import styled from "styled-components";

const Grow = styled.li`
  flex-grow: 1;
`;

export default Grow;
